import type { TeacherData } from '@/models/interface/teacher';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class TeacherService extends ApiFactory {
  constructor() {
    super('Teacher');
  }

  /**
   *
   * @param status 0: 在職老師(預設)，1:包含已離職在內所有老師
   * @returns
   */
  fetchTeacherList(status?: number): Promise<ApiDataResponse<TeacherData[]>> {
    return this.get(`TeacherList?status=${status ?? 0}`);
  }
}
